

export const GifPath = {
    logo: require("./gif-files/logo-small.gif"),
    // mainlogo: require("./gif-files/logo-main.gif"),
};